// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".coupon[data-v-3f1cc1a1]{border:2px dashed orange;border-radius:5px;margin-right:15px;margin-bottom:15px}.coupon__image[data-v-3f1cc1a1]{display:table-cell;width:30%}.coupon__image img[data-v-3f1cc1a1]{width:90%}.coupon__data[data-v-3f1cc1a1]{vertical-align:top;display:table-cell;height:100%;width:50%}.coupon__brand[data-v-3f1cc1a1]{display:table-cell;vertical-align:middle;width:20%}.coupon__brand>img[data-v-3f1cc1a1]{margin-left:10%;width:80%;border-radius:50%}", ""]);
// Exports
module.exports = exports;
